import { ToastBarType } from '../types/toastBar.type';
import { TOAST_ICON } from './Offline';

const DEFAULT_DELAY = 3000;

/** Builds the "your request is taking a while" toast — same icon and duration as the offline one. */
export const buildSlowConnectionToast = (message: string): ToastBarType => ({ message, iconName: TOAST_ICON, delay: DEFAULT_DELAY });
